<template>
  <b-card
    title="Choix de la boucle"
    v-if="form">
    <b-form-group label="Boucle logistique:" label-for="exampleInputLoop" style="width: 100%">
      <b-form-select v-show="loops" :options="loops" required v-model="form.logistic_loop" />
    </b-form-group>
  </b-card>
</template>
<script>
// /!\ CODE CONSTRUCTION FOR EMPLACEMENT = ZONE + POS_Y + POS_X + POS_Z
//                                       =  S   +   Z   +   7   +   A
import server from '../../api/server.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'LoopSelector',
  props: {
      readOnly: {
        type: Boolean,
        default: false
      },
      loops: {
          type: Array,
          default: () => []
      }
    },
  computed: {
     ...mapGetters({
      form: 'getFormKanban'
    })
  },
  methods: {
      getAllLoops() {
        server.getLoops().then((result) => {
          result.data.forEach(element => {
              var item = {
                    'value': element.name,
                    'text':  element.description
                    }
            // pour pouvoir commit en fait
              this.loops.push(item)
          });
        })
      }
  },
  mounted: function () {
      if (_.isEmpty(this.loops)) {
          this.getAllLoops()
      }
  },
  components: {  }
};
</script>



// WEBPACK FOOTER //
// src/components/kanban/LoopSelector.vue